// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__17QNJ","left":"StickyBox_left___mgCz","right":"StickyBox_right__2b-AA"};